<!-- 教室设置 -->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <el-collapse   v-model="activeName" accordion>
      <el-collapse-item :name="1">
        <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template>
        <!--查询条件区域-->
        <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
          <div class="filter-container" style="margin-top: 10px ;display:none;">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="店铺:">
                <el-input v-model="queryParam.shopFrontId" placeholder="店铺ID"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-container" style="margin-top: 10px">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="教室名称:">
                <el-input v-model="queryParam.classroomName" placeholder="教室名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div>
        </el-card>
      </el-collapse-item>

    </el-collapse>


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        v-loading="listLoading"
        ref="seleteTable"
        max-height="650"
        border>
        <el-table-column prop="classroomCode" label="教室代码" ></el-table-column>
        <el-table-column prop="classroomName" label="教室名" ></el-table-column>
        <el-table-column prop="usefulness" label="用途" ></el-table-column>
        <el-table-column prop="region" label="所在区域" ></el-table-column>
        <el-table-column prop="floor" label="楼层" ></el-table-column>
        <el-table-column prop="studentsNumber" label="容纳人数" ></el-table-column>
        <el-table-column prop="status" label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">启用</span>
            <span v-if="scope.row.status == 1">停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button> -->
            <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              :page-sizes="queryParam.pageSizes"
              :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--    添加-->
    <el-dialog
            title="新增"
            :visible.sync="visibleDlg"
            width="50%"
            center>
      <classroom-detail
              :detail-param="createParam"
              :create-type=1
              @onBtnOK="onBtnOK"
              @onClassroom="onClassroom"
              @onBtnCancel="onBtnCancel()"
      >
      </classroom-detail>
    </el-dialog>
    <el-dialog
            title="修改教室"
            :visible.sync="visibleDlgUpdate"
            width="50%"
            center>
      <div>
        <el-form  ref="registerRef"  label-width="150px">
          <!-- <el-form-item label="教室编码" >
            <el-input  maxlength="20"  show-word-limit v-model="updateParam.classroomCode" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="教室名称" >
            <el-input  maxlength="20"  show-word-limit v-model="updateParam.classroomName" placeholder="" style="width: 300px;"></el-input>
          </el-form-item> -->
          <el-form-item  label="教室编号:"  prop="classroomCode">
            <el-input style="width: 300px" v-model="updateParam.classroomCode" placeholder=""></el-input>
          </el-form-item>
          <el-form-item  label="教室名称:" prop="classroomName" >
            <el-input style="width: 300px" v-model="updateParam.classroomName" placeholder=""></el-input>
          </el-form-item>

          <el-form-item  label="用途:" prop="usefulness" >
            <el-input style="width: 300px" v-model="updateParam.usefulness"></el-input>
          </el-form-item>
          <el-form-item  label="所在区域:" prop="region" >
            <el-input style="width: 300px" v-model="updateParam.region"></el-input>
          </el-form-item>

          <el-form-item  label="所在楼层:" prop="floor" >
            <el-input style="width: 300px" v-model="updateParam.floor"></el-input>
          </el-form-item>
          <el-form-item  label="可以容纳的学生数:" prop="studentsNumber" >
            <el-input style="width: 300px" v-model="updateParam.studentsNumber"></el-input>
          </el-form-item>
          <el-form-item  label="状态:" prop="status" >
          <el-select v-model="updateParam.status" placeholder="状态">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item  label="备注:" >
            <el-input
                    type="textarea"
                    placeholder=""
                    v-model="updateParam.remark"
                    maxlength="30"
                    show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgUpdate = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateOne">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {queryClassroom, addClassroom,delClassroom,updateClassroom} from "../../../api/Classroom";
  import classroomDetail from "./components/classroomDetail";
  import messageUtils from "../../../utils/messageUtils";


  export default {
    components:{classroomDetail},
    data() {
      return {
        listLoading: true,
        //查询参数
        queryParam: {
          shopFrontId:globaldata.getAdminStore().storeFrontId,
          //分页查询
          pageNum :1 ,//当前第几页
          pageSize : 10,
        },
        totalPage :1, //总共页数
        pageSizes:[20,50,100],
        //查询区域默认展开
        activeName:1,
        createParam :{
        },
        //删除
        deleteParam :{
        },
        updateParam:{
          id:'',
          shopFrontId:'',
          classroomCode:'',
          classroomName :''  ,
          usefulness : '' ,
          region : '' ,
          floor : '' ,
          studentsNumber : '',
          remark:'',
        },
        //弹窗
        visibleDlg: false,
        visibleDlgUpdate :false,
        //表单结果
        tableData: [
        ],
        allWorker:[],
        options: [{
          value: '0',
          label: '启用'
        }, {
          value: '1',
          label: '停用'
        }],
      }


    },
    created(){
      this.fitchList()
    },
    mounted() {

    },
    methods: {

      //点击查询按钮
      onBtnSearch() {
        this.fitchList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      refreshData(list){
        this.tableData = list;
      },
      //添加一个
      handleCreateOne(){
        this.visibleDlg = true;
      },
      onBtnOK(){
        this.visibleDlg = false;
        this.fitchList();
      },
      //新增保存
      onClassroom(data){
        data.shopFrontId =globaldata.getAdminStore().storeFrontId;

        addClassroom(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
          this.fitchList();
        })
      },
      onBtnCancel(){
        this.visibleDlg = false;
      },
      //刪除
      handleDeleteOne(row){
        console.info('删除')
        this.$confirm('是否要删除教室名为：'+ row.classroomName +' 的教室?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          let param = {
            id:row.id,
          }
          delClassroom(param).then(response => {
            let data = response.data;
            if (data == true){
              messageUtils.successMsg(this,response.message);
              this.fitchList();
            }else {
              messageUtils.errorMsg(this,response.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      fitchList(){
        this.listLoading = true;
        queryClassroom(this.queryParam).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;

          this.refreshData(data.list);
        })
      },
      //打开修改弹出框
      handleUpdateOneDlg(row){
        this.visibleDlgUpdate =true;
        this.updateParam = {
          id:row.id,
          shopFrontId:row.shopFrontId,
          classroomCode:row.classroomCode,
          classroomName:row.classroomName,
          usefulness:row.usefulness,
          region:row.region,
          floor:row.floor,
          studentsNumber:row.studentsNumber,
          status:row.status,
          remark:row.remark,
        }
      },
      handleUpdateOne() {
        let param = {
          id : this.updateParam.id,
          shopFrontId:globaldata.getAdminStore().storeFrontId,
          classroomCode:this.updateParam.classroomCode,
          classroomName:this.updateParam.classroomName,
          usefulness:this.updateParam.usefulness,
          region:this.updateParam.region,
          floor:this.updateParam.floor,
          studentsNumber:this.updateParam.studentsNumber,
          status:this.updateParam.status,
          remark:this.updateParam.remark,
        }
        updateClassroom(param).then(response =>
        {
          let data = response.data;
          if (data == true){
            messageUtils.successMsg(this,response.message);
            this.fitchList();
            this.visibleDlgUpdate= false;
          }else {
            messageUtils.errorMsg(this,response.message);
          }
        })
      },
    }
  }



</script>






// WEBPACK FOOTER //
// src/views/my-store/classroom/index.vue